module.exports = __webpack_public_path__ + "img/face31.0e519e84.gif";